import { createSlice } from '@reduxjs/toolkit';
import { ICompanyInitial } from './company.types';
import { actions } from './company.actions';

const initialState: ICompanyInitial = {
  total: 0,
  isLoading: false,
  currentPage: 1,
  filters: {
    search: '',
    status: '',
  },
  currentCompany: {
    id: '',
    countryId: '',
    countryName: '',
    isActive: true,
    name: '',
    registrationCode: '',
    representativesName: '',
    role: '',
    basedOnTheDocument: '',
    companyAddress: '',
    bankAccountNumber: '',
    bankName: '',
    bankAddress: '',
    bankCode: '',
    companyDetailsList: [],
  },
  companies: [],
};

const companySlice = createSlice({
  name: 'companySlice',
  initialState,
  reducers: actions,
});

export const companyReducer = companySlice.reducer;
export const { setCurrentPage, setFilters, setCurrentCompany } = companySlice.actions;
